import { DateSearchComponent } from './date-search.component'
import { MonthSearchComponent } from './month-search.component'
import { LabelFiltersComponent } from './label-filters.component'
import { MultiSelectSearchOptionComponent } from './multi-select-search-option.component'
import { MultiSelectSearchComponent } from './multi-select-search.component'
import { SingleSelectSearchComponent } from './single-select-search.component'
import { SingleSelectSearchOptionComponent } from './single-select-search-option.component'
import { TextSearchComponent } from './text-search.component'
import { TextSearchAndSortLinkComponent } from './text-search-and-sort-link.component'

export * from './label-filter'
export { DateSearchComponent }
export { MonthSearchComponent }
export { LabelFiltersComponent }
export { MultiSelectSearchOptionComponent }
export { MultiSelectSearchComponent }
export { SingleSelectSearchOptionComponent }
export { SingleSelectSearchComponent }
export { TextSearchComponent }
export { TextSearchAndSortLinkComponent }

export const SEARCH_COMPONENTS = [
  DateSearchComponent,
  MonthSearchComponent,
  LabelFiltersComponent,
  MultiSelectSearchOptionComponent,
  MultiSelectSearchComponent,
  SingleSelectSearchOptionComponent,
  SingleSelectSearchComponent,
  TextSearchComponent,
  TextSearchAndSortLinkComponent
]



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/search/index.ts